import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";
const { Item } = Form;

export const SelectField: CSSProperties = {
  color: theme.colors.text,
  fontFamily: theme["@font-family"],
  height: theme["@height-input-lg"],
};

export const FilterOptionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 15px;
  max-height: 100%;
  opacity: 1;
  transition: all 0.4s linear;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: ${(props) => props.theme["@height-input-lg"]} !important;
  }
  .ant-select.ant-tree-select.ant-select-multiple {
    margin-top: 8px !important;
  }
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    border-right-width: 0;
    background-color: ${(props) => props.theme["@hover-input-wrapper"]} !important;
  }

  .ant-select-multiple .ant-select-selection-item {
    border-radius: 17px !important;
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
    :hover {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: 1.6px solid ${(props) => props.theme["@hover-input-background-color"]} !important;
    }
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto auto;
    grid-auto-flow: row;

    & > :nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }
    & > :nth-child(2) {
      grid-column: 2;
      grid-row: 1;
    }
    & > :nth-child(3) {
      grid-column: 3;
      grid-row: 1;
    }
    & > :nth-child(4) {
      grid-column: 1 / span 3;
      grid-row: 2;
    }
  }
`;

export const ButtonsFilter = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;
  align-items: center;
  .ant-btn-primary {
    height: ${(props) => props.theme["@height-button-lg"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: none;
    color: ${(props) => props.theme.colors.text};
    :hover,
    :focus {
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      color: ${(props) => props.theme.colors.text};
      border: none;
    }
  }

  .secondaryButton {
    height: ${(props) => props.theme["@height-button-lg"]};
    color: ${(props) => props.theme.colors.text};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1.6px solid ${(props) => props.theme.colors.text} !important;
    height: ${(props) => props.theme["@height-button-lg"]};
    :hover {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: 1.6px solid ${(props) => props.theme["@hover-input-background-color"]} !important;
      color: ${(props) => props.theme.colors.text};
    }
  }

  .ant-btn[disabled],
  .ant-btn[disabled]:active,
  .ant-btn[disabled]:focus,
  .ant-btn[disabled]:hover {
    background-color: ${(props) => props.theme["@muted-background"]} !important;
    border: 1.6px solid ${(props) => props.theme["@muted-background"]} !important;
    color: ${(props) => props.theme["@disabled-button"]} !important;
  }
`;

export const StatusFilter = styled.div`
  display: grid;
`;

export const Label = styled.span`
  font-family: ${(props) => props.theme["@font-family"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
  margin-bottom: 8px !important;
`;

export const SearchLabel = styled.span`
  font-family: ${(props) => props.theme["@font-family"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
  margin-bottom: 18px !important;
`;

export const FormItem = styled(Item)`
  .ant-form-item-control-input-content > input {
    margin-left: 0;
    border: 1px solid ${(props) => props.theme.colors.manatee};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .ant-form-item-label > label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    pointer-events: none !important;
  }

  .ant-form-item-label {
    text-align: start;
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: 300;
    padding: 3px 0;
    z-index: 1;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid ${(props) => props.theme.colors.manatee};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    }
  }

  .ant-input-disabled {
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      cursor: default;
      > input {
        background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
        border: none !important;
      }
    }
  }
  .ant-form-item-control-input-content > .ant-input.ant-input-status-error {
    border: 1.6px solid ${(props) => props.theme["@danger-color"]} !important;
    background-color: ${(props) => props.theme["@danger-background"]};
    :hover {
      border-color: ${(props) => props.theme["@danger-color"]};
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
  }
`;

export const DescriptionField: CSSProperties = {
  width: "100%",
  height: theme["@height-input-lg"],
  borderRadius: "4px",
  marginTop: "8px",
  fontSize: theme["@medium-font-size"],
};
